import React, { useEffect } from "react";

//import ControlledCasousel from "./ControlledCarousel";
import CarouselJson from "../components/CarouselJson";
import { AUTHENTICATION_TYPES } from "../constants";
import { GET_ACCESS_TOKEN_END_POINT_PREFIX } from "../constants/api.constants";

const Home = () => {
  useEffect(() => {
    const fetchAccessTokenAndRedirect = async ({
      authentication_type,
      code,
      fromPage,
      jobNumber,
    }) => {
      try {
        const response = await fetch(
          `${GET_ACCESS_TOKEN_END_POINT_PREFIX}/login?type=${authentication_type.toLowerCase()}&code=${code}`
        );
        const JSONData = await response.json();
        console.log(
          "response fetched in async await",
          JSON.stringify(JSONData)
        );
        let email;
        let userName;
        if (authentication_type === AUTHENTICATION_TYPES.LINKEDIN) {
          email = JSONData.elements[0]["handle~"]["emailAddress"];
          userName =
            `${JSONData.localizedFirstName} ${JSONData.localizedLastName}`.trim();
        } else {
          email = JSONData.email;
          userName = JSONData.username;
        }

        if (JSONData.access_token) {
          localStorage.setItem("access_token", JSONData.access_token);
          localStorage.setItem("expires_in", JSONData.expires_in);
          localStorage.setItem("authentication_type", authentication_type);
          localStorage.setItem(
            "expires_at",
            JSONData.expires_in * 1000 + Date.now()
          );
          localStorage.setItem("email", email);
          localStorage.setItem("username", userName);
        }

        const domainUrl = window.location.origin;

        console.log("redirecting to submit job", fromPage);
        if (fromPage === "submitjob") {
          window.location.href =
            domainUrl + `/#/submit?jobNumber=${jobNumber}&fromPage=submitjob`;
        } else if (fromPage === "postjob") {
          window.location.href = domainUrl + `/#/postjob?fromPage=postjob`;
        } else {
          window.location.href = domainUrl + "/#" + queryString;
        }
      } catch (err) {}
    };

    // call api or anything
    let queryString = window.location.search;
    // console.log(queryString);
    const url = window.location.href;
    const RqueryString = url.split("?");
    const appendString = "?" + RqueryString[1];
    const urlParams = new URLSearchParams(appendString);
    const code = urlParams.get("code");
    const state = urlParams.get("state");

    if (window.location.href.includes("code")) {
      console.log("has code and fetching access token");
      const [authentication_type, fromPage, jobNumber] = state.split(",") || [
        "",
        "",
        "",
      ];
      fetchAccessTokenAndRedirect({
        authentication_type,
        code,
        fromPage,
        jobNumber,
      });
    }
  }, []);

  return (
    <body ng-app="docsTemplateUrlDirective">
      <div className="page">
        <div className="mainBody">
          <br />
          <div className="aboutBlock">
            <CarouselJson />
          </div>

          <div className="aboutBlock">
            <div className="abtContent">
              <div className="content padLarge" align="center">
                <span
                  className="homeTitle"
                  style={{ color: "rgb(23, 134, 161)" }}
                >
                  
                </span>
                <div className="cta">
                  <div>
                    <img src={require("../images/hpe_pri_grn_pos_rgb.png")} alt="" />
                    <br />
                    <b>HPE</b> is our biggest client.  We partner with HPE GreenLakes team, 
                    to build high performing Engineering Teams. Placed nearly 100 resources over 
                    period of 40 months.{" "}
                  </div>
                </div>
                <div className="cta">
                  <div>
                    <img src={require("../images/stem-logo.png")} alt="" />
                    <br />
                    <b>STEM</b> engaged our solutions Architect to develop 
                    {" "}
                    <a href="https://www.terraform.io">
                      Infrastructure As Code
                    </a>
                    <a> </a>framework,  write terraform code to build multi-region AWS cloud Infrastructure, <a> </a>
                    <a href="https://kubernetes.io">
                    container orchestrator
                    </a>
                    , and <a> </a>
                    <a href="https://argoproj.github.io/cd/">
                    GitOps release process
                    </a>.
                    {" "}
                  </div>
                </div>
                <div className="cta">
                  <div>
                    <img src={require("../images/missioncloud-black.png")} alt="" />
                    <br />
                    We partnered with <b>MissionCloud</b>{" "}
                    to provide cloud consulting services. In last
                    3 years, we delivered nearly 10+ projects, such as Building CI/CD pipelines, multi-region network Architecture, App modernization and Cloud migrations. {" "}
                  </div>
                </div>
                <div className="cta">
                  <div>
                    <img src={require("../images/haulr-logo.png")} alt="" />
                    <br />
                    <a href="https://haulr.biz">Haul'r</a>{" "}
                    a solution to bring construction companies and Trucker to one
                    platform to deliver fast pacing Truck hiring process to haul dirt.  We are developing Mobile Applcation 
                    using React Native for both iOS and Andriod devices. {" "}
                  </div>
                </div>
                <br />
                <br />
                <br />
              </div>
            </div>
          </div>
          <div className="productsBlock">
            {/* <div className="proContent">
            <div className="contentHome padLarge" align="center">
              <div className="contentLeft">
                <span className="homeTitle" style={{ color: `obj.#fff` }}>
                  Our Clients
                </span>
                <div className="customers">
                  <div className="custLogo">
                    <div className="cLogo">
                      <img src={require("../images/hpe-logo.png")} alt="" />
                    </div>
                  </div>
                  <div className="custLogo">
                    <div className="cLogo">
                      <img
                        src={require("../images/stem-logo.png")}
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="custLogo">
                    <div className="cLogo">
                      <img
                        src={require("../images/volvo-logo.png")}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
            {/* <div style={{ clear: "both", height: "50px" }}></div> */}
          </div>
        </div>
      </div>
    </body>
  );
};

export default Home;
